import classNames from 'classnames';
import { type ReactNode, useId, useState } from 'react';
import VerticalSlide from '@alltrails/core/components/VerticalSlide';
import Chevron from '@alltrails/denali/icons/Chevron';
import styles from './styles/styles.module.scss';

export type ExpandableProps = {
  children: ReactNode;
  contentClassName?: string;
  externalControls?: {
    isOpen: boolean;
    toggleIsOpen: () => void;
  };
  iconColor?: '--color-text-primary' | '--color-text-primary-inverse';
  isBorderHidden?: boolean;
  title: ReactNode;
};

const Expandable = ({
  title,
  contentClassName,
  children,
  externalControls,
  iconColor = '--color-text-primary',
  isBorderHidden = false
}: ExpandableProps) => {
  const [internalIsOpen, setInternalIsOpen] = useState(false);

  const toggleIsOpen = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    if (e.target instanceof HTMLAnchorElement) {
      return;
    }

    if (externalControls) {
      externalControls.toggleIsOpen();
    } else {
      setInternalIsOpen(prevState => !prevState);
    }
  };

  const isOpen = externalControls ? externalControls.isOpen : internalIsOpen;
  const id = useId();

  return (
    <div className={classNames(styles.container, { [styles.noBorder]: isBorderHidden })}>
      <button aria-controls={id} className={styles.titleAndTrigger} onClick={toggleIsOpen} tabIndex={0} type="button">
        <div className={styles.title}>{title}</div>
        <div className={classNames(styles.expandButton, { [styles.rotated]: isOpen })}>
          <Chevron size="sm" color={iconColor} orientation="down" />
        </div>
      </button>
      <VerticalSlide id={id} className={contentClassName} isOpen={isOpen}>
        <>
          <div className={styles.sixteenSpacer} />
          {children}
        </>
      </VerticalSlide>
    </div>
  );
};

export default Expandable;
